import { render, staticRenderFns } from "./TablaCantidadInscritosPrograma.vue?vue&type=template&id=1c6c0423"
import script from "./TablaCantidadInscritosPrograma.vue?vue&type=script&lang=js"
export * from "./TablaCantidadInscritosPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports